import { render, staticRenderFns } from "./AboutDialog.vue?vue&type=template&id=41d69969&scoped=true&"
import script from "./AboutDialog.vue?vue&type=script&lang=js&"
export * from "./AboutDialog.vue?vue&type=script&lang=js&"
import style0 from "./AboutDialog.vue?vue&type=style&index=0&id=41d69969&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d69969",
  null
  
)

export default component.exports